import type { SortOption } from "@decocms/apps-commerce/types"
import { portugueseMappings } from "~/components/search/Sort"
import Icon from "~/components/ui/Icon"
import stripTrackingParams from "~/sdk/stripTrackingParams"
import { SITE } from "~/constants"

interface ProductOrderByProps {
    url: string
    sortOptions: SortOption[]
    isMobile?: boolean
}

export const ProductOrderBy = ({ url, sortOptions, isMobile }: ProductOrderByProps) => {
    // Não repassar tracking/PII (utm_*, gclid, ?email=…) nos links de
    // ordenação (DECO-5819).
    const URLi = stripTrackingParams(new URL(url ?? "/", SITE.URL))
    const params = URLi.searchParams

    const selectedSortOptionLabel = params.get('O')
        ? portugueseMappings[
            params.get('O') as keyof typeof portugueseMappings
        ] ?? 'Ordenar por:'
        : 'Ordenar por:'

    const _sortOptions = Object.entries(portugueseMappings)
        .filter(([key]) => sortOptions.some((option) => option.label === key))
        .map(([key, label]) => {
            const { value } = sortOptions.find(({ label }) => label === key) ?? {}

            if (!value) throw new Error('value not found')

            params.set('O', value)
            // Trocar a ordenação recomeça da primeira página
            params.delete('page')

            return {
                key: value,
                href: URLi.href,
                label,
            }
        })

    if (isMobile) {
        return (
            <div className='w-full relative bg-white text-black border border-[#eee] h-12'>
                <input
                    id='ordenar-por'
                    type='checkbox'
                    className='fixed hidden peer'
                />
                <label
                    className='px-4 h-full w-full flex justify-between items-center text-sm cursor-pointer'
                    htmlFor='ordenar-por'
                >
                    <span>{selectedSortOptionLabel}</span>
                    <Icon id='FilledChevronDown' size={7} />
                </label>
                <div className='absolute top-full left-0 overflow-y-auto transition-all max-h-0 bg-white border-neutral-200 w-full shadow-lg text-sm peer-checked:max-h-[400px] peer-checked:border z-[1]'>
                    <ul className='flex flex-col divide-y divide-solid divide-[#eee]'>
                        {_sortOptions.map(({ key, label, href }) => (
                            <li className='p-2'>
                                <a key={key} href={href}>
                                    <span className='text-sm'>{label}</span>
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        )
    }

    return (
        <div>
            <div className='relative bg-white text-black border border-[#eee] w-[144px] px-2 cursor-pointer'>
                <input
                    id='ordenar-por'
                    type='checkbox'
                    className='fixed hidden peer'
                />
                <label
                    className='h-[27px] w-full flex justify-between items-center text-xs'
                    htmlFor='ordenar-por'
                >
                    <span>{selectedSortOptionLabel}</span>
                    <Icon id='FilledChevronDown' size={7} />
                </label>
                <div className='absolute z-[2] top-full left-0 overflow-y-auto transition-all max-h-0 peer-checked:max-h-[400px] bg-white border border-neutral-200 w-full shadow-lg text-xs'>
                    <ul className='flex flex-col py-3 tracking-tighter'>
                        {_sortOptions.map(({ key, label, href }) => (
                            <li>
                                <a className='px-2' key={key} href={href}>
                                    <span className='text-sm'>{label}</span>
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    )
}
